import { render, staticRenderFns } from "./HomeRetainTab.vue?vue&type=template&id=a79d4470"
import script from "./HomeRetainTab.vue?vue&type=script&lang=js"
export * from "./HomeRetainTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports